// Router de plataforma para la pantalla Chat. Elige la variante web o
// móvil según getPlatform(). NO contiene lógica ni JSX — solo despacha.
//
// Tipos compartidos: re-exportados desde Chat.shared para que el resto del
// código (MessageBubble, etc.) los importe de './Chat' sin saber nada de
// esta separación.
import { lazy, Suspense } from 'react';
import { isWeb, isTablet } from '../platform';

const ChatWeb = lazy(() => import('./Chat.web'));
const ChatMobile = lazy(() => import('./Chat.mobile'));

export default function Chat(
  props: React.ComponentProps<typeof import('./Chat.shared').default>,
): JSX.Element {
  // iPad / tablet → vista web de 2 paneles (como WhatsApp/Telegram/Signal).
  const View = (isWeb() || isTablet()) ? ChatWeb : ChatMobile;
  return (
    <Suspense fallback={null}>
      <View {...props} />
    </Suspense>
  );
}

export type {
  ChatMessage,
  TextMessage,
  MediaMessage,
  ContactCardMessage,
  LocationMessage,
  LiveLocationMessage,
} from './Chat.shared';
